import React from 'react';
import Box from 'components/react-styled-core/Box';

const Section = ({ children }) => (
    <Box
        bg="white"
        border="1px solid"
        borderColor="gray:50"
        borderRadius="4px"
        p={['6x', '6x', '8x']}
        my="6x" // 24px
    >
        {children}
    </Box>
);

export default Section;
